import { DanceManagerInterface } from '../../..';

export class DanceManagerDto implements DanceManagerInterface {
  id: string;
  name: string;
  urlName: string;
  imageUrl: string;
}
